import React, { createContext, useContext, useEffect, useState } from "react";
import { authApi, setToken, getToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null); // { user, organization }
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const boot = async () => {
      if (getToken()) {
        try {
          const data = await authApi.me();
          setSession({ user: data.user, organization: data.organization });
        } catch (e) {
          setToken(null);
        }
      }
      setReady(true);
    };
    boot();
  }, []);

  const login = async (email, password) => {
    try {
      const data = await authApi.login(email, password);
      setToken(data.token);
      const s = { user: data.user, organization: data.organization };
      setSession(s);
      return { session: s, user: data.user };
    } catch (e) {
      return { error: e?.response?.data?.detail || "Invalid email or password" };
    }
  };

  const signup = async (payload) => {
    try {
      const data = await authApi.signup(payload);
      if (data.pending) {
        return { pending: true, message: data.message };
      }
      setToken(data.token);
      const s = { user: data.user, organization: data.organization };
      setSession(s);
      return { session: s, user: data.user };
    } catch (e) {
      return { error: e?.response?.data?.detail || "Could not create account" };
    }
  };

  const logout = () => {
    setToken(null);
    setSession(null);
  };

  const value = { session, ready, login, signup, logout };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
